export enum AccountingRoles {
    LOCAL_ADMIN = 'LocalAdmin',
    ACCOUNTANT = 'Accountant',
    SCM = 'SCM'
}
